import React from 'react'
import { Truckbody, Tires, Road, Infinity } from "./AllSvg";


const TruckLoader = ({ container }) => {
    return (
        <>
            <div className={container ? "container-center-loader" : "screen-center-loader"}>
                <div className="truckWrapper">
                    <div className="truckBody">
                        <Truckbody color={'black'} />
                    </div>
                    <div class="truckTires">
                        <Tires />
                        <Tires />
                    </div>
                    <div className="road"></div>
                    <Road />
                </div>
            </div>
        </>
    )
}

const Loader = ({ container }) => {
    return (
        <>
            <div className={container ? "container-center-loader" : "screen-center-loader"}>
                <div className="infinity-loader">
                    <Infinity />
                </div>
            </div>
        </>
    )
}

export default Loader